var exports = {
  "Ze": "AddFriendView.module__friendRequestContainer___QldSSG",
  "Nr": "AddFriendView.module__card___QldSSG",
  "Og": "AddFriendView.module__heroIcon___QldSSG",
  "DD": "AddFriendView.module__title___QldSSG",
  "VA": "AddFriendView.module__subtitle___QldSSG",
  "KJ": "AddFriendView.module__formContainer___QldSSG",
};

module.exports = exports;
